import { useTranslation } from "react-i18next";
import checkIcon from "../icons/check.svg";

const GeneratePopup = ({ open, entity, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[1050]">
      <div className="w-[614px] h-[376px] bg-white shadow-[0px_20px_80px_#00000011] rounded-[12px] p-6">
        {/* Icon Section */}
        <div className="flex justify-center mb-6">
          <div className="w-28 h-28 bg-[#FFD166] rounded-full flex items-center justify-center">
          <img src={checkIcon} alt="Icon" className="w-20 h-16" />
          </div>
        </div>

        {/* Message Section */}
        <div className="text-center py-4 px-12 text-[#36495C] font-medium text-[20px]" style={{ fontFamily: "Montserrat" }}>
          <p>{t("placeholder.generate")} <strong className="text-[#FFD166]">{entity}</strong> ?</p>
        </div>

        {/* Button Section */}
        <div className="flex justify-center gap-4 mt-10">
          <button
            onClick={onCancel}
            className="w-[40%] py-2 rounded-[12px] text-[#00000] text-lg font-medium hover:opacity-80"
          >
            {t("placeholder.no")}
          </button>
          <button
            onClick={onConfirm}
            className="w-[40%] py-2 rounded-[12px] bg-[#FFD166] text-white text-lg font-medium hover:opacity-80"
          >
            {t("placeholder.yes")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GeneratePopup;
